import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationType } from '@app/shared/interfaces';
import { IntercomService } from '@app/shared/services/intercom.service';
import { LogService, LogStatus } from '@app/shared/services/logs/log.service';
import { TitleService } from '@app/shared/services/title/title.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';

@Component({
  standalone: false,
  selector: 'sbnb-log-detail',
  templateUrl: './log-detail.component.html',
  styleUrls: ['./log-detail.component.scss'],
})
export class LogDetailComponent implements OnInit {
  logStatus = LogStatus;
  loading: boolean;
  logData: any;
  uuid: string;
  editMessageMode: boolean;
  newMessage: string;
  updating: boolean;
  cancelling: boolean;

  constructor(
    private titleService: TitleService,
    private logService: LogService,
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastNotificationsService,
    private readonly intercomService: IntercomService
  ) { }

  ngOnInit() {
    this.titleService.manuallySet('Operations Log');
    this.loading = true;

    this.route.params.subscribe((params) => {
      this.uuid = params['uuid'];

      this.fetchLogData();
    });
  }

  fetchLogData() {
    this.logService.getOperationsLog(this.uuid).subscribe((res) => {
      this.logData = res;
      this.loading = false;

      if (!this.logData?.uuid) {
        this.toast.open('Log not found.', 'Dismiss', NotificationType.Error);
        this.router.navigate(['/operations/log']);
      }

      this.titleService.manuallySet(`${this.logData.ruleset} to ${this.logData.mate?.name}`);

      this.logData.send_status = '';

      if (this.logData.sent_at) {
        this.logData.send_status = 'sent';
      }

      if (this.logData.cancelled_at) {
        this.logData.send_status = 'cancelled';
      }

      if (this.logData.scheduled_for && !this.logData.cancelled_at && !this.logData.sent_at) {
        this.logData.send_status = 'scheduled';
      }

      if (this.logData.failed) {
        this.logData.send_status = 'failed';
      }
    });
  }

  updateLog(attr: any) {
    this.updating = true;

    this.logService.updateOperationsLog(this.uuid, this.newMessage).subscribe((res) => {
      attr.text = this.newMessage;
      this.updating = false;
      this.editMessageMode = false;
      this.newMessage = null;
    });
  }

  cancelNotification() {
    this.cancelling = true;

    this.logService.cancelOperationsLog(this.uuid).subscribe((res) => {
      this.cancelling = false;
      this.logData = res;
    });
  }

  goBack() {
    this.router.navigate(['/operations/log']);
  }

  reportProblem() {
    const messageText = `Please investigate an issue I'm having with Operations log report ${(window as any).location.href
      }`;
    this.intercomService.showNewMessage(messageText);
  }

  openRule(rulesetId) {
    this.router.navigate(['/operations/task-rules/task/' + rulesetId]);
  }
}
